<form [formGroup]="targetForm" [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
    <section class="sideRight-body es-employee-shelf">

        <div id="container-header">
            <div id="contentD">
                <i class="fas fa-user">
                </i>
            </div>

            <div id="contentE">
                <h4><b>Employee Details</b></h4>
            </div>
        </div>

        <div id="container">
            <div id="contentA" class="ei-employeeNumber mt-2">
                <label for="ei-employeeNumber">
                    <i class="fas fa-asterisk"></i> Employee Number
                    <span *ngIf="f.employeeNumber.errors && (f.employeeNumber.touched || f.employeeNumber.dirty)">
                        <span class="required-error" *ngIf="f.employeeNumber.errors.required">(required)</span>
                    </span>
                    <input id="emp-number" class="black-input opposite-colors" placeholder="Employee Number" type="text"
                        no-special-chars="#!$%^<>+='" maxlength="100" (blur)="trimSpecialChar('employeeNumber');"
                        (input)="onEditEmpData()" formControlName="employeeNumber" disabled>
                </label>
            </div>


            <div id="contentB" class="ei-name mt-2">
                <label for="ei-name">
                    <i class="fas fa-asterisk"></i> Employee Name
                    <span *ngIf="f.name.errors && (f.name.touched || f.name.dirty)">
                        <span class="required-error" *ngIf="f.name.errors.required">(required)</span>
                    </span>
                    <input class="black-input opposite-colors" placeholder="Name of Employee" type="text"
                        pattern="[^'\x22\x60]+" maxlength="100" (blur)="trimSpecialChar('name')"
                        (input)="onEditEmpData()" formControlName="name" required>
                </label>
            </div>
        </div>

        <div class="form-error-sign section-info" *ngIf="employeeNumberError">
            <p>Employee number is already in use or is invalid.</p>
        </div>

        <div id="container">
            <div id="contentA" class="ei-title mt-2">
                <label for="ei-title">
                    Job Title
                    <input class="black-input opposite-colors" placeholder="Job Title" type="text"
                        no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('title');" (input)="onEditEmpData()"
                        formControlName="title" maxlength="200">
                </label>
            </div>
            <div id="contentB" class="ei-type mt-2">
                <label for="ei-type">
                    Employment Type
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors pointer" placeholder="Select" type="text"
                            no-special-chars="#!$%^<>+='" maxlength="100"
                            (blur)="trimSpecialChar('type');dropdownInputChanged()" (input)="dropdownInputChanged()"
                            (click)="dropdownInputChanged()" formControlName="type" (selectItem)="dropdownInputChanged()"
                            [kpmgUiTypeahead]="searchEmploymentType" aria-autocomplete="none" aria-expanded="false"
                            role="combobox">
                        <i class="fas fa-caret-down"></i>
                    </div>
                </label>
            </div>
        </div>

        <div class="alert alert-danger section-info" role="alert" *ngIf="displayNoResultsEmployment"><i
                class="fas fa-exclamation-triangle"></i> No Employment Type Found</div>

        <div id="container-header" class="header-space">
            <div id="contentD">
                <i class="fas fa-building">
                </i>
            </div>

            <div id="contentE">
                <h4><b>Cost Center</b></h4>
            </div>
        </div>

        <div id="container">
            <div id="contentA" class="ei-location mt-2">
                <label for="ei-location">
                    Location
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors pointer" placeholder="Name of Location" type="text"
                            (input)="dropdownInputChanged()" formControlName="location" (selectItem)="dropdownInputChanged()"
                            [kpmgUiTypeahead]="searchLocation" no-special-chars="#!$@%^<>+=" aria-autocomplete="none"
                            aria-expanded="false" role="combobox" (blur)="dropdownInputChanged()"
                            (click)="dropdownInputChanged()">
                        <i class="fas fa-caret-down"></i>
                    </div>
                </label>
            </div>

            <div id="contentB" class="ei-costCenter mt-2">
                <label for="ei-costCenter">
                    Cost Center Number
                    <input class="black-input opposite-colors" placeholder="Cost Center Number" type="text"
                        no-special-chars="#!$%^<>+='" maxlength="100" (blur)="trimSpecialChar('costCenter');"
                        (input)="onEditEmpData()" formControlName="costCenter">
                </label>
            </div>
        </div>

        <div class="alert alert-danger section-info" role="alert" *ngIf="displayNoResultsLocation"><i
                class="fas fa-exclamation-triangle"></i> No Location Found</div>

        <div id="container">
            <div id="contentC" class="ei-costCenterDesc mt-2">
                <label for="ei-costCenterDesc">
                    Cost Center Description
                    <input class="black-input opposite-colors" placeholder="Cost Center Description" type="text"
                        no-special-chars="#!$%^<>+='" maxlength="100" (blur)="trimSpecialChar('costCenterDesc');"
                        (input)="onEditEmpData()" formControlName="costCenterDesc">
                </label>
            </div>
        </div>

        <div id="container-header" class="header-space">
            <div id="contentD">
                <i class="fas fa-calendar">
                </i>
            </div>

            <div id="contentE">
                <h4><b>Employment Details</b></h4>
            </div>
        </div>

        <div id="container">
            <div id="contentA" class="ei-employment-dates mt-2">
                <label for="ei-hireDate">
                    Hire Date
                    <span class="input-group startdate-input">
                        <input type="text" class="black-input opposite-colors " #dpStart="bsDatepicker"
                            no-special-chars="#!$%^<>+='" [ngClass]="{'ng-invalid': employmentDatesError}" bsDatepicker
                            [maxDate]="maxDate" placeholder="MM/DD/YYYY"
                            [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                            (bsValueChange)="setStartDate($event)" formControlName="hireDate"
                            (focus)="onfocStartDate()" />
                        <span class="input-group-append">
                            <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.hireDate"
                                (click)="clearStartDate()"></i>
                            <i class="fa fa-calendar-alt" (click)="openDatePickerStart()"></i>
                        </span>
                    </span>
                </label>
            </div>

            <div id="contentB" class="ei-employment-dates mt-2">
                <label for="ei-endDate">
                    Termination Date
                    <span class="input-group enddate-input">
                        <input type="text" class="black-input opposite-colors" #dpEnd="bsDatepicker"
                            no-special-chars="#!$%^<>+='" [ngClass]="{'ng-invalid': employmentDatesError}" bsDatepicker
                            [maxDate]="maxDate" placeholder="MM/DD/YYYY"
                            [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                            (bsValueChange)="setEndDate($event)" (input)="onEditEmpData()" formControlName="endDate"
                            (blur)="checkDates()" (focus)="onfocEndDate()" />
                        <span class="input-group-append">
                            <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.endDate"
                                (click)="clearEndDate()"></i>
                            <i class="fa fa-calendar-alt" (click)="openDatePickerEnd()"></i>
                        </span>
                    </span>
                </label>
            </div>
        </div>

        <div class="form-error-sign section-info" *ngIf="employmentDatesError">
            <p>{{employeeDatesErrorMessage}}</p>
        </div>

        <div id="container">
            <div id="contentA" class="ei-totalHours mt-2">
                <label for="ei-totalHours">
                    Computed Hours
                    <input class="black-input opposite-colors" placeholder="Enter Total Hours" type="number"
                        (input)="onEditEmpData()" formControlName="totalHours"readonly style="cursor: not-allowed;">
                </label>
            </div>

            <div id="contentB" class="ei-wage mt-2">
                <label for="ei-wage">
                    Wage Amount
                    <input class="black-input opposite-colors" placeholder="Enter Wage Amounts" type="number"
                        formControlName="wage" (input)="onEditEmpData()" (blur)="checkWage()">
                </label>
            </div>
        </div>

        <div id="container">

            <div id="contentA" class="ei-wage mt-2">
                <label for="ei-pyq">
                    PY Qualified Allocation
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="0" min="0" max="100"
                            (input)="onEditEmpData()" formControlName="priorYearQualifiedPercentage" type="number">
                        <i class="fas fa-percent"></i>
                    </div>
                </label>
            </div>
            <div id="contentB" class="ei-totalHours mt-2">
                <label for="ei-location">
                    <i class="fas fa-asterisk"></i> Tax Period
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors pointer" placeholder="Tax Period" type="text"
                            (input)="dropdownInputChanged()" formControlName="taxPeriod" (selectItem)="dropdownInputChanged()"
                            [kpmgUiTypeahead]="searchTaxPeriod" no-special-chars="#!$@%^<>+=" aria-autocomplete="none"
                            aria-expanded="false" role="combobox" (blur)="dropdownInputChanged()"
                            (click)="dropdownInputChanged()">
                        <i class="fas fa-caret-down" [ngClass]="{'caret-disabled' : taxPeriodNames?.length == 1}"></i>
                    </div>
                </label>
            </div>
        </div>

        <p class="section-info">Wage can have decimal values.</p>

        <div class="form-error-sign section-info" *ngIf="f.wage.errors && f.wage.errors.cannotBeNegativeNumber">Wage
            cannot be a negative number.</div>

        <div id="container">
            <div id="contentA" class="ei-sme mt-2">
                <label for="ei-sme">
                    SME
                    <div class="input-elm">
                        <input class="black-input opposite-colors" placeholder="Enter a Client User Name" type="text"
                        (selectItem)="dropdownInputChanged()"   formControlName="sme" (input)="onEditEmpData()" [kpmgUiTypeahead]="searchSMEStream">
                        <span class="search-icon"><i class="fas fa-search"></i></span>
                    </div>
                </label>
            </div>

            <div id="contentB" class="ei-company mt-2">
                <label for="ei-company">
                    Entity
                    <input class="black-input opposite-colors" placeholder="Entity Name" type="text"
                        (selectItem)="dropdownInputChanged()" no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('company');"
                        maxlength="100" (input)="onEditEmpData()" formControlName="company">
                </label>
            </div>
        </div>
    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success"
            [disabled]="!targetForm.valid || employmentDatesError || isDisabled || addDisabledLocation || addDisabledEmployment || addDisabledTaxPeriod"
            (click)="putRightSideDrawerData()">Save Changes</button>
        <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
    </footer>
</form>